import {
  LISTINGS_UTM_CONTENT_KEY,
  type ListingUTMSourceMap,
} from "@/components/listings/listing-utm-content-tracker";

export function getUTMSources(listingId: number): string[] {
  const data = localStorage.getItem(LISTINGS_UTM_CONTENT_KEY);

  if (!data) {
    return [];
  }

  try {
    const parsedMap = JSON.parse(data) as ListingUTMSourceMap;

    if (!parsedMap) {
      return [];
    }

    if (parsedMap[listingId]) {
      return parsedMap[listingId];
    }

    return [];
  } catch {
    return [];
  }
}
